export const UNDERTONES = ["warm", "cool", "neutral", "olive"];
export const TEXTURES = ["straight", "wavy", "curly", "coily"];
export const LENGTHS = ["shaved", "short", "medium", "long"];
export const SHAPES = [
  { value: "rectangle", label: "Rectangle" },
  { value: "hourglass", label: "Hourglass" },
  { value: "pear", label: "Pear" },
  { value: "inverted_triangle", label: "Inverted triangle" },
  { value: "athletic", label: "Athletic" },
  { value: "round", label: "Round" },
];

export const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
